// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DeclineIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DeclineIcon" ref={forwardedRef} {...props}>
      <path d="M7.694 6.625 10 8.932l2.306-2.307 1.065 1.066-2.306 2.307 2.31 2.311-1.065 1.066L10 11.064l-2.31 2.311-1.065-1.066 2.31-2.311-2.306-2.307z" />
      <path d="M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 6.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DeclineIcon = /* @__PURE__ */ Object.assign(DeclineIconComponent, {
  displayName: 'DeclineIcon',
});
